/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'match';
const componentName = 'http-method-match-readonly';
const prefix = `${moduleName}.${componentName}`;

export const httpMethodLabel = `${prefix}.httpMethodLabel`;

export const ENGLISH = {
    [httpMethodLabel]: 'HTTP Method',
};
